import React from 'react';
import kebabCase from 'lodash-es/kebabCase';
import * as S from './styled';
export const TabPillsItem = ({ appearance, size, label, active, onClick }) => (React.createElement(S.Tab, { key: kebabCase(label), appearance: appearance, size: size, active: active, onClick: onClick }, label));
